import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-bottom: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.secondary.border};
`;

export const Title = styled(Typography.Title).attrs({ $variant: '2' })``;

export const ResetButton = styled(Button).attrs<{ disabled: boolean }>({
  hasPadding: false,
  appearance: 'transparent',
})`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.brand.main};

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme }) => theme.palette.tertiary.labels};
    `}
`;
